import { actionType } from './actions';

const initialState = {
    addNewUserData: {
        userModelId: '',
        firstName: '',
        lastName: '',
        accountId: '',
        clientId: '',
        email: '',
        password: '',
        roleName: '',
        userName: ''
    },
    editUserData: {
        userModelId: '',
        firstName: '',
        lastName: '',
        accountId: '',
        clientId: '',
        email: '',
        password: '',
        roleName: '',
        userName: ''
    },
    viewUserData: {
        userModelId: '',
        firstName: '',
        lastName: '',
        accountId: '',
        clientId: '',
        email: '',
        password: '',
        roleName: '',
        userName: ''
    },
    users: [],
    selectedItemData: {},
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_USER_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_USER_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_USERS: {
            return {
                ...state,
                users: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.FETCH_USER: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_USER_SELECTED: {
            return {
                ...state,
                selectedItemData: action.payload
            };
        }

        case actionType.ADD_NEW_USER: {
            return {
                ...state,
                users: [action.payload, ...state.users],
                addNewUserData: {
                    userModelId: '',
                    firstName: '',
                    lastName: '',
                    accountId: '',
                    clientId: '',
                    email: '',
                    password: '',
                    roleName: '',
                    userName: ''
                },
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.EDIT_USER: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }


        case actionType.UPDATE_ADD_NEW_USER_PAYLOAD: {
            return {
                ...state,
                addNewUserData: action.payload
            };
        }

        case actionType.UPDATE_EDIT_USER_PAYLOAD: {
            return {
                ...state,
                editUserData: action.payload
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/user/reducers.js